module.exports = __webpack_public_path__ + "img/jianzhu.3c783e31.png";